<template>
  <div>
    <DailyStudentAttendanceFilters
      filter-views="Day"
      :filters="['Day']"
      :already-selected-displayed-columns="filtersData?.displayedColumns"
      :is-calendar-show="true"
      @apply="applyFilters"
      @applyDate="applyDate"
    />
    <div>
      <div class="items-center justify-center">
        <section class="main-content rounded-md -mt-5">
          <template v-if="isLoading">
            <Loader class="mt-20 mb-40 h-64 pt-12 pb-40" :content="true" />
          </template>
          <div v-else>
            <DailyStudentAttendanceDayView
              v-if="filterView === 'Day'"
              :list="attendance"
              :current-date="currentDate"
              user-name="Student Name"
              :filters-data="filtersData"
              :table-headers="tableHeaders"
              @update="updateDailyListView"
            >
              <template v-slot:notFound>
                <p v-i18n="attendanceTranslation" class="text-center py-5 text-4xl text-action-bg">
                  <NoRecordFound />
                </p>
              </template>
            </DailyStudentAttendanceDayView>
          </div>
          <Pagination
            v-if="dayViewCount > GENERAL_CONSTANTS.RECORD_LIMIT && filterView === 'Day'"
            v-show="!isLoading"
            :key="`update-pagination-${forceRender}`"
            class="mx-1"
            :record-limit="filteredRecordLimit"
            :max-range="paginationCounts(dayViewCount, filteredRecordLimit)"
            @filterRecord="loadDayRecord"
          />
        </section>
      </div>
    </div>
    <MarkDailyStudentAttendanceModal
      v-if="isMarkAttendance"
      :modal="isMarkAttendance"
      @toggle="toggleAttendanceModal"
    />
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty'
import Loader from '@components/BaseComponent/Loader.vue'
import { formatDateFromLocalToUTC } from '@/src/utils/moment.util.js'
import DATE_TIME_FORMAT from '@src/constants/date-time-constants.js'
import { mapActions, mapState, mapGetters } from 'vuex'
import { formatTimeOnly } from '@src/utils/moment.util.js'
import { formatDateString } from '@utils/format-date'
import timeMixin from '@src/mixins/timeMixin'
import Pagination from '@components/BaseComponent/Pagination.vue'
import GeneralMixin from '@src/mixins/general-mixins.js'
import NoRecordFound from '@src/components/BaseComponent/NoRecordFound.vue'
/* UTILS */
import { getTimeRange } from '@utils/timeTableUtils'
import {
  getStudentAttendanceWeek,
  getSubjectEvent,
} from '@src/router/views/attendance/CheckInOutUtils.js'
import { convertUTCTimeIntoLocalTime } from '@/src/utils/generalUtil'
import {
  INITIAL_START_TIME,
  INITIAL_END_TIME,
} from '@/src/constants/attandance/attandance-constant'
import FILTER_KEYS from '@src/constants/filter-constants.js'
import GENERAL_CONSTANTS from '@src/constants/general-constants'
import { getCurrentDate } from '@utils/moment.util'
import dailyStudentAttendanceData from '@src/router/views/attendance/daily-attendance/student-daily-attendance/dailyStudentAttendanceData.json'
import { paginationRangeHandler } from '@src/components/BaseComponent/pagination.util.js'
import fileMixin from '@src/mixins/file-mixins'
import { objectDeepCopy } from '@utils/generalUtil'
import DailyStudentAttendanceDayView from './DailyStudentAttendanceDayView.vue'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import MarkDailyStudentAttendanceModal from './MarkDailyStudentAttendanceModal.vue'
import DailyStudentAttendanceFilters from './DailyStudentAttendanceFilters.vue'
export default {
  name: 'StudentSectionAttendance',
  components: {
    Pagination,
    DailyStudentAttendanceFilters,
    Loader,
    MarkDailyStudentAttendanceModal,
    NoRecordFound,
    DailyStudentAttendanceDayView,
  },
  mixins: [timeMixin, fileMixin, GeneralMixin],
  data() {
    return {
      isEmpty,
      GENERAL_CONSTANTS,
      forceRender: 0,
      filterName: null,
      isLoading: false,
      defaultSelectedColumns: dailyStudentAttendanceData.defaultSelectedColumns,
      tableHeaders: dailyStudentAttendanceData.tableHeaders,
      forceRenderCalendar: 1,
      filterView: 'Day',
      title: 'title',
      attendanceTranslation: 'attendanceTranslation',
      currentDate: getCurrentDate(),
      dateTimeRange: null,
      isMobileDevices: window.matchMedia('(max-width: 1023px)').matches,
      filteredRecordLimit: GENERAL_CONSTANTS.RECORD_LIMIT,
      filtersData: {},
      dayViewCount: 0,
      attendance: [],
      dayModal: false,
      student_id: null,
      get currentStudent() {
        return JSON.parse(localStorage.getItem('currentActiveStudent')) || null
      },
      isMarkAttendance: false,
    }
  },
  page: {
    title: 'Daily Attendance | Student',
    meta: [
      {
        name: 'description',
        content: 'Daily Student Attendance on the basis of campus',
      },
    ],
  },
  computed: {
    ...mapState({
      currentCampusScope: (state) => state.layout.currentCampusScope?.id,
      studentCheckInModal: (state) => state.layout.studentCheckInModal,
      studentCheckOutModal: (state) => state.layout.studentCheckOutModal,
      BulkCheckOutModal: (state) => state.layout.BulkCheckOutModal,
    }),
    ...mapGetters('layout', ['campusTimeZone']),
    dateTimeFormat() {
      return (datetime) => formatTimeOnly(datetime)
    },
  },
  watch: {
    BulkCheckOutModal: {
      deep: true,
      immediate: true,
      handler() {
        if (this.BulkCheckOutModal) {
          this.toggleAttendanceModal()
          this.setBulkCheckOutModal()
          this.mobileRightBar()
        }
      },
    },
    currentCampusScope: {
      deep: true,
      handler() {
        this.applyDateFilter()
      },
    },
    currentDate: {
      deep: true,
      handler(value) {
        if (value) {
          this.applyDateFilter()
        }
      },
    },
  },

  created() {
    this.mobileRightBar()
    const stat = {}
    this.rightBarStats(stat)
  },
  mounted() {
    this.applyDateFilter()
  },
  methods: {
    getCurrentDate,
    applyFilters(filtersPayload) {
      this.filtersData = objectDeepCopy(filtersPayload)
      this.applyDateFilter()
    },
    formatTimeOnly,
    toggleAttendanceModal(payload) {
      this.isMarkAttendance = !this.isMarkAttendance
      if (payload) this.applyDateFilter()
    },
    updateDailyListView() {
      this.forceRender++
      const data = { skip: GENERAL_CONSTANTS.RECORD_SKIP, limit: GENERAL_CONSTANTS.RECORD_LIMIT }
      this.loadDayRecord(data)
    },
    /**
     * Mobile Right Bar
     * @description Closes right bar in mobile view when an action is performed
     */
    mobileRightBar() {
      if (this.isMobileDevices) this.$store.commit('layout/SET_TAB_RIGHT_BAR', false)
    },

    /*
     * Set right bar static data and update it after server response
     * Get stat as param which contain stats get from server
     */
    rightBarStats(stat, status) {
      const rightBarContent = {
        header: {
          title: 'Attendance',
          buttons: [
            ...(this.currentStudent
              ? []
              : [
                  {
                    title: 'MARK_DAILY_ATTENDANCE',
                    classes: ['primary-button-right'],
                    action: { name: 'layout/setBulkCheckOutModal', payload: {} },
                    permissions: { roles: ['super_admin', 'campus_admin', 'section_teacher'] },
                  },
                ]),
          ],
        },
        stats: [
          {
            title: GENERAL_CONSTANTS.STATS_AND_SUMMARY,
            categories: [
              {
                text: 'TOTAL_ATTENDANCE',
                value: stat?.total_records || GENERAL_CONSTANTS.EMPTY_RECORD,
              },
              {
                text: 'TOTAL_PRESENTS',
                value: stat?.total_present || GENERAL_CONSTANTS.EMPTY_RECORD,
                roles: [
                  TENANT_ROLES.SUPER_ADMIN,
                  TENANT_ROLES.SECTION_TEACHER,
                  TENANT_ROLES.CAMPUS_ADMIN,
                ],
              },
              {
                text: 'TOTAL_ABSENTS',
                value: stat?.total_absent || GENERAL_CONSTANTS.EMPTY_RECORD,
                roles: [
                  TENANT_ROLES.SUPER_ADMIN,
                  TENANT_ROLES.SECTION_TEACHER,
                  TENANT_ROLES.CAMPUS_ADMIN,
                ],
              },
              {
                text: 'TOTAL_TARDY',
                value: stat?.total_tardy || GENERAL_CONSTANTS.EMPTY_RECORD,
                roles: [
                  TENANT_ROLES.SUPER_ADMIN,
                  TENANT_ROLES.SECTION_TEACHER,
                  TENANT_ROLES.CAMPUS_ADMIN,
                ],
              },
            ],
          },
        ],
      }
      this.setRightbarContent(rightBarContent)
    },
    applyDate(date) {
      this.currentDate = date
    },
    handleClick(status) {
      switch (status) {
        case 'close':
        case 'cancel':
          this.dayModal = false
        default:
          break
      }
    },

    /*
     * Load check-in-out weekly  data
     */

    getDay(date) {
      return new Date(date).getDate()
    },

    getTimeOnly(time) {
      const timeObj = time.split(' ')

      return timeObj[0]
    },
    resetFilter() {
      this.student_id = null
      this.applyDateFilter()
    },
    /*
     * filter data on monthly , weekly and daily view
     */
    applyDateFilter() {
      if (!this.currentCampusScope) return

      let data = {}
      if (this.student_id) {
        data.user_id = this.student_id
      }
      data.user_type = 'section_student' // filtering data for the section student
      data = this.filtersData ? { ...data, ...{ $where: this.filtersData?.$where } } : data
      this.forceRender++
      switch (this.filterView) {
        case 'Day':
          data.skip = 0
          data.limit = this.filteredRecordLimit
          this.loadDayRecord(data)
      }
    },
    loadDayRecord(range = {}) {
      let paginationPayload = paginationRangeHandler(range)
      let date = formatDateFromLocalToUTC(this.currentDate, DATE_TIME_FORMAT.DATE)
      let payload = {
        ...paginationPayload,
        ...{
          $where: {
            ...range?.$where,
            ...this.filtersData?.$where,
            attendance_date: {
              [FILTER_KEYS.GREATER_THAN_EQUAL]: date,
              [FILTER_KEYS.LESS_THAN_EQUAL]: date,
            },
          },
        },
      }
      this.isLoading = true
      this.getDailyAttendanceList(payload)
        .then((resp) => {
          this.attendance = resp?.records
          this.dayViewCount = resp?.meta?.total_records
          this.rightBarStats(resp?.meta)
        })
        .catch((err) => {
          this.isLoading = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeStudentCheckModal() {
      if (this.studentCheckInModal) {
        this.$store.dispatch('layout/setStudentCheckInModal')
      } else if (this.studentCheckOutModal) {
        this.$store.dispatch('layout/setStudentCheckOutModal')
      }
    },

    ...mapActions('layout', ['setRightbarContent', 'setBulkCheckInModal', 'setBulkCheckOutModal']),
    ...mapActions('attendance', ['getDailyAttendanceList']),
  },
}
</script>
